import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './MenuCheum.scss';

export default class MenuCheum extends Component {
  static propTypes = {
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    return (
      <nav className={`menu-cheum ${this.props.className}`}>
        {this.props.children}
      </nav>
    );
  }
}